import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';
import { isPresent } from '@ember/utils';

export default class Group extends RESTSerializer {
  normalize(modelClass, payload, prop) {
    // Handle the 'membershipHidden' property
    if (!isPresent(payload.membershipHidden)) {
      payload.membershipHidden = false;
    }

    // Assign default properties to the payload
    let defaults = {
      status: 1,
    };
    Object.assign(defaults, payload);
    payload = defaults;

    // Call the _super method with the modified payload
    return super.normalize(modelClass, payload, prop);
  }
}
